import { createAction } from 'redux-act';
import { createAsyncAction } from '@alycecom/utils';

import { IBranding } from '../../types/Branding.types';
import { ICodeRequestParams } from '../types/Request.types';

const prefix = 'BRANDING';

export const fetchBranding = createAsyncAction<ICodeRequestParams, IBranding, void>(`${prefix}/FETCH_BRANDING`);

export const applyBranding = createAction<Partial<IBranding>>(`${prefix}/APPLY_BRANDING`);
